<template>
	<section class="my-modal-custom">
		<div class="align-center">
			<div class="container-modal animate__animated animate__fadeInDown">
				<div class="box-modal">
					<div class="modal-title">
						<h1>Aprovar #{{ `PM${payment.id}` }}</h1>
						<feather class="feather-icon" type="x" size="14" @click="$emit('close')" />
					</div>

					<div
						v-if="dataErrors.length === 0 && !orderFixed.message && !loading"
						class="box-container"
					>
						<div v-if="hasPaymentProcess && loadingPaymentProcess === false">
							<div class="grouped_row_container">
								<div class="grouped_row">
									<span class="title-label"> Valor Pago: </span>
									<Input
										border-radius="5px"
										type="text"
										width="100%"
										height="28px"
										:is-disable="true"
										:value="transformToBrl(order.value)"
										:format-money="true"
										margin-top="10px"
										@value="data.vlrpago = $event"
									/>
								</div>
								<div class="grouped_row">
									<span class="title-label"> NSU<Asterisk />: </span>
									<Input
										:border-focused="!inputError.nsu ? '#7159C7' : '#CC352D'"
										:border-color="!inputError.nsu ? '#cecece' : '#CC352D'"
										border-radius="5px"
										type="number"
										width="100%"
										height="28px"
										:is-disable="false"
										:format-money="true"
										margin-top="10px"
										@value="data.nsu = $event"
									/>
									<div class="error-message">
										<p>{{ error.nsu.message }}</p>
									</div>
								</div>
							</div>
							<div class="list-collumn">
								<span class="title-label"> Autorização<Asterisk />: </span>
								<Input
									:border-focused="!inputError.autorizacao ? '#7159C7' : '#CC352D'"
									:border-color="!inputError.autorizacao ? '#cecece' : '#CC352D'"
									border-radius="5px"
									type="number"
									width="100%"
									height="28px"
									:is-disable="false"
									:format-money="true"
									margin-top="7px"
									@value="data.autorizacao = $event"
								/>
								<div class="error-message">
									<p>{{ error.autorizacao.message }}</p>
								</div>
							</div>
							<div class="list-collumn">
								<span class="title-label"> Nome do Titular<Asterisk />: </span>
								<Input
									:border-focused="!inputError.nomerazao ? '#7159C7' : '#CC352D'"
									:border-color="!inputError.nomerazao ? '#cecece' : '#CC352D'"
									border-radius="5px"
									type="text"
									width="100%"
									height="28px"
									:is-disable="false"
									:format-money="true"
									margin-top="7px"
									@value="data.nomerazao = $event"
								/>
								<div class="error-message">
									<p>{{ error.nomerazao.message }}</p>
								</div>
							</div>
							<div class="list-collumn">
								<div class="grouped_row_container">
									<div class="grouped_row">
										<span class="title-label"> CPF/CNPJ do Titular<Asterisk />: </span>
										<Input
											:border-focused="!inputError.cpfcnpj ? '#7159C7' : '#CC352D'"
											:border-color="!inputError.cpfcnpj ? '#cecece' : '#CC352D'"
											border-radius="5px"
											type="text"
											width="100%"
											height="28px"
											mask="cpfcpnj"
											margin-top="7px"
											@value="data.cpfcnpj = $event"
										/>
									</div>
									<div class="grouped_row">
										<span class="title-label"> Últimos dígitos do cartão<Asterisk />: </span>
										<Input
											:border-focused="!inputError.lastdigits ? '#7159C7' : '#CC352D'"
											:border-color="!inputError.lastdigits ? '#cecece' : '#CC352D'"
											border-radius="5px"
											type="number"
											width="100%"
											height="28px"
											:is-disable="false"
											:format-money="true"
											margin-top="7px"
											mask="lastdigits"
											@value="data.lastdigits = $event"
										/>
									</div>
								</div>
								<div class="error-message">
									<p>{{ error.cpfcnpj.message }}</p>
								</div>
								<div class="error-message">
									<p>{{ error.lastdigits.message }}</p>
								</div>
							</div>
							<div class="list-collumn">
								<div class="grouped_row_container">
									<div class="grouped_row">
										<span class="title-label"> Bandeira<Asterisk />: </span>
										<Input
											:border-focused="!inputError.brand ? '#7159C7' : '#CC352D'"
											:border-color="!inputError.brand ? '#cecece' : '#CC352D'"
											border-radius="5px"
											type="text"
											width="100%"
											height="28px"
											:is-disable="false"
											:format-money="true"
											margin-top="7px"
											@value="data.brand = $event"
										/>
									</div>
									<div class="grouped_row">
										<span class="title-label"> Parcelas<Asterisk />: </span>
										<Input
											:border-focused="!inputError.number_installments ? '#7159C7' : '#CC352D'"
											:border-color="!inputError.number_installments ? '#cecece' : '#CC352D'"
											border-radius="5px"
											type="number"
											width="100%"
											height="28px"
											:is-disable="false"
											:format-money="true"
											margin-top="7px"
											:value="parseFloat(1)"
											@value="data.number_installments = $event"
										/>
									</div>
								</div>
								<div class="error-message">
									<p>{{ error.brand.message }}</p>
								</div>
								<div class="error-message">
									<p>{{ error.number_installments.message }}</p>
								</div>
							</div>
							<div class="list-collumn">
								<span class="title-label"> Anexar comprovante<Asterisk />: </span>
								<input id="file-input" type="file" accept="image/*" @change="uploadImage($event)" />
								<div class="error-message">
									<p>{{ error.image.message }}</p>
								</div>
							</div>
						</div>
						<div
							v-else-if="!hasPaymentProcess && loadingPaymentProcess === false"
							class="box-container"
						>
							<div class="w-60">
								<img src="../../../assets/icons/creditcard.svg" alt="" />
							</div>
							<p class="text-center p-3">
								O pedido foi validado com sucesso! <br />
								<small>Após iniciar o processo de pagamento manual, o pedido ficará indisponível para
									edição, até que o pagamento seja concluído, ou cancelado.</small>
							</p>
						</div>
						<!--<div v-else>loading</div>-->
					</div>
					<div v-else class="box-container-error">
						<div class="container-error">
							<img src="../../../assets/icons/error.svg" alt="" />
						</div>
						<div class="sucess-messages">
							<div class="sucess-box">
								<p>Valor do Pedido: {{ transformToBrl(order.value) }}</p>
							</div>
						</div>
						<div v-if="orderFixed.message && !loading" class="sucess-messages">
							<div class="sucess-box">
								<p>
									{{ orderFixed.message }}
									<a
										title="Ver detalhes do pedido"
										target="_blank"
										rel="noopener noreferrer"
										class="link"
										:href="returnUrl(modalData.pedido_id)"
										><feather class="icon-info" type="info" size="15" /></a>
								</p>
							</div>
						</div>
						<div
							v-for="errorData of dataErrors"
							:key="errorData.errCode || errorData.message"
							class="error-message-custom"
						>
							<div class="error-box">
								<p>{{ errorData.message }}</p>
								<p v-for="item of errorData.unavailableItems" :key="item.produtoId">
									Id do Produto: {{ item.produtoId }} <br />
									Quantidade Pedida: {{ item.qtdRequested }}<br />
									Quantidade Disponível: {{ item.maxAvailable }}<br />
								</p>
							</div>
						</div>
					</div>
					<div class="container-buttons">
						<div
							v-if="dataErrors.length === 0 && !orderFixed.message && hasPaymentProcess"
							class="confirmButton"
							@click="createNewPayment()"
						>
							<feather v-if="!loading" class="icon-downloas" type="check" size="15" />
							<div v-else class="loader-icon" />
							Confirmar
						</div>
						<div
							v-if="dataErrors.length === 0 && !orderFixed.message && !hasPaymentProcess"
							class="confirmButton"
							@click="startManualPaymentProcess()"
						>
							<feather
								v-if="loadingPaymentProcess === false"
								class="icon-downloas"
								type="check"
								size="15"
							/>
							<div v-else class="loader-icon" />
							Iniciar Processo
						</div>

						<div
							v-if="dataErrors.length > 0"
							class="confirmButton"
							@click="fixErrors(modalData.pedido_id)"
						>
							<feather v-if="!loading" class="icon-downloas" type="settings" size="15" />
							<div v-else class="loader-icon" />
							Resolver Erros
						</div>
						<div
							v-if="dataErrors.length === 0 && orderFixed.message"
							class="confirmButton"
							@click="orderFixes = []"
						>
							<feather v-if="!modalLoading" class="icon-downloas" type="settings" size="15" />
							<div v-else class="loader-icon" />
							Continuar
						</div>
						<div class="cancelbutton" @click="cancelManualPayment()">
							<feather class="icon-downloas" type="x" size="15" />
							Cancelar
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import cookie from 'vue-cookie';
import axios from 'axios';
import Input from '../input/default';
import global from '../../../mixins/global';
import Asterisk from '../miscellaneous/asterisk';
import * as ecAxios from '../../../util/ecAxios';

export default {
	components: {
		Input,
		Asterisk,
	},
	mixins: [global],
	props: {
		modalData: {
			type: Object,
			default: () => {},
		},
		modalLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			errrors: [],
			order: {
				value: 0,
			},
			orderFixes: {},
			loading: false,
			payment: {},
			token: cookie.get('admtoken'),
			uploadError: true,
			uploadData: null,
			error: {
				lastdigits: {
					message: '',
				},
				nsu: {
					message: '',
				},
				number_installments: {
					message: '',
				},
				brand: {
					message: '',
				},
				autorizacao: {
					message: '',
				},
				cpfcnpj: {
					message: '',
				},
				nomerazao: {
					message: '',
				},
				uploadError: {
					message: '',
				},
				image: {
					message: '',
				},
			},
			data: {
				vlrPago: 0,
				nsu: 0,
				nomerazao: null,
				cpfcnpj: null,
				autorizacao: null,
				lastdigits: null,
				brand: '',
				number_installments: 1,
			},
			inputError: {
				vlrPago: false,
				nsu: false,
				nomerazao: false,
				cpfcnpj: false,
				autorizacao: false,
				lastdigits: false,
				number_installments: false,
				image: false,
			},
			inputValue: '',
			regraError: false,
			hasPaymentProcess: false,
			loadingPaymentProcess: false,
		};
	},
	computed: {
		orderFixed() {
			return this.orderFixes;
		},
		dataErrors() {
			return this.errrors;
		},
	},
	created() {
		this.validOrder();
		this.getPaymentDetails();
	},
	methods: {
		async startManualPaymentProcess() {
			this.handlePaymentProcess(10);
		},
		async cancelManualPayment() {
			if (this.hasPaymentProcess === true) {
				if (
					!window.confirm(
						'Ao cancelar o processo de pagamento manual, o pedido voltará para a situação salvo, e poderá ser editado pelo cliente. Tem certeza que deseja continuar?'
					)
				) {
					return;
				}
				await this.handlePaymentProcess(0);
			}

			this.$emit('close');
		},
		async sendObservation(observation) {
			this.loading = true;
			const payload = {
				tipo: 2,
				observacao: observation.text,
				pedido_id: observation.pedido_id,
				created_by: cookie.get('logUser'),
			};
			const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_OBSERVATION}`;
			await ecAxios.connection().put(url, payload);
			this.loading = false;
		},
		returnUrl(orderId) {
			return `${process.env.VUE_APP_HOST}/order/${orderId}/details`;
		},
		async fixErrors(orderId) {
			this.loading = true;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}/pedido/fix/${orderId}`;
				const response = await ecAxios.connection().put(url);
				this.order.value = response.data.orderValue;
				if (response.data.error === 1) {
					this.errrors.push(response.data);
				} else {
					this.orderFixes = response.data;
					if (response.data.message_id !== 1) {
						this.sendObservation({
							text: response.data.message,
							pedido_id: orderId,
							created_by: cookie.get('logUser'),
						});
					}
					this.validOrder();
				}
			} catch (e) {
				this.$buefy.notification.open({
					message: e.message || 'Ops! Ocorreu um erro ao carregar os dados.',
					type: 'is-danger',
				});
			}
			this.loading = false;
		},
		async validOrder() {
			this.loading = true;
			this.errrors = [];
			this.regraError = false;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}/pedido/validate/${this.modalData.pedido_id}`;
				const request = await ecAxios.connection().get(url);
				const validationData = request.data.errors;
				this.order.value = request.data.orderValue;
				this.hasPaymentProcess = request.data.hasPaymentProcess;
				validationData.forEach((validation) => {
					if (validation.error === 1) {
						if (validation.errorCode === 1014) {
							this.regraError = true;
						} else {
							this.errrors.push(validation);
						}
					}
				});
			} catch (e) {
				this.$buefy.notification.open({
					message: e.message || 'Ops! Ocorreu um erro ao carregar os dados.',
					type: 'is-danger',
				});
			}
			this.loading = false;
		},
		getFileNameWithExt(event) {
			if (!event || !event.target || !event.target.files || event.target.files.length === 0) {
				return { fileName: null, extension: null, error: 1 };
			}
			const { name } = event.target.files[0];
			const lastDot = name.lastIndexOf('.');

			const fileName = name.substring(0, lastDot);
			const ext = name.substring(lastDot + 1);
			return { fileName, extension: ext, error: 0 };
		},
		async uploadImage(event) {
			this.uploadData = event;
			try {
				if (this.uploadData.target.files[0]) {
					const fileName = this.getFileNameWithExt(this.uploadData);
					if (fileName.error !== 1) {
						const formData = new FormData();
						formData.append('name', `PM${this.payment.id}.${fileName.extension}`);
						formData.append('image', event.target.files[0]);
						const config = {
							headers: { 'Content-Type': 'multipart/form-data', Accept: '*/*' },
						};
						const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.GN_COMPROVANTE_PGTO_UPLOAD}?token=${this.token}`;
						await axios.post(url, formData, config);
						this.uploadError = false;
						this.error.image.message = '';
					} else {
						this.uploadError = true;
					}
					this.uploadData = null;
				}
			} catch (e) {
				// se der erro já vai cair aqui, tudo que está entre http 200 e http 300 o axios já considera como erro.
				// eslint-disable-next-line no-console
				console.error(e.response.data.message || e);
				this.uploadError = true;
			}
		},
		notification(message, type) {
			this.$buefy.notification.open({
				message: message.toString(),
				type,
			});
		},
		createNewPayment() {
			if (this.data.lastdigits.length !== 4) {
				this.inputError.lastdigits = true;
				this.error.lastdigits.message = 'Dados incorretos, adicione apenas 4 digitos';
			} else {
				this.inputError.lastdigits = false;
				this.error.lastdigits.message = '';
			}
			if (this.data.nsu.length < 3) {
				this.inputError.nsu = true;
				this.error.nsu.message = 'NSU incorreto';
			} else {
				this.inputError.nsu = false;
				this.error.nsu.message = '';
			}
			if (this.data.nomerazao.length < 3) {
				this.inputError.nomerazao = true;
				this.error.nomerazao.message = 'Nome muito pequeno, por favor adicione o nome completo';
			} else {
				this.inputError.nomerazao = false;
				this.error.nomerazao.message = '';
			}
			if (this.data.brand.length < 3) {
				this.inputError.brand = true;
				this.error.brand.message = 'Nome da bandeira inválido';
			} else {
				this.inputError.brand = false;
				this.error.brand.message = '';
			}
			if (this.data.cpfcnpj.length < 3) {
				this.inputError.cpfcnpj = true;
				this.error.cpfcnpj.message = 'Cnpj Inválido';
			} else {
				this.inputError.cpfcnpj = false;
				this.error.cpfcnpj.message = '';
			}
			if (this.data.autorizacao.length <= 3) {
				this.inputError.autorizacao = true;
				this.error.autorizacao.message = 'Autorização Inválida';
			} else {
				this.inputError.autorizacao = false;
				this.error.autorizacao.message = '';
			}
			if (!this.data.number_installments) {
				this.error.number_installments.message =
					'Campo vazio, favor preencher com o número de parcelas';
				this.inputError.number_installments = true;
			} else {
				this.inputError.number_installments = false;
				this.error.number_installments.message = '';
			}
			if (this.uploadError) {
				this.error.image.message = 'Você não enviou o comprovante, por favor faça o upload.';
				this.inputError.image = true;
			}
			if (
				!this.inputError.lastdigits &&
				!this.inputError.nsu &&
				!this.inputError.nomerazao &&
				!this.inputError.cpfcnpj &&
				!this.inputError.brand &&
				!this.inputError.autorizacao &&
				!this.inputError.number_installments &&
				!this.uploadError
			) {
				const sendData = {
					payment_id: `PM${this.payment.id}`,
					payment_type: 'credit',
					order_id: this.modalData.pedido_id,
					status: 'CONFIRMED',
					documento: this.data.cpfcnpj,
					descriptionDetail:
						`Pagamento aprovado por: ${cookie.get('logUser')}` || 'Usuário não Encontrado',
					customer_id: this.payment.customerId,
					pedido_id: this.modalData.pedido_id,
					number_installments: this.data.number_installments,
					brand: this.data.brand,
					customerName: this.data.nomerazao,
					terminal_nsu: this.data.nsu,
					authorization_code: this.data.autorizacao,
					lastDigits: this.data.lastdigits,
				};
				this.$emit('confirm-pay-manual', sendData);
			}
		},
		async getPaymentDetails() {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}/pedidopgtocartao/detailed/1/${this.modalData.pedido_id}`;
				const request = await ecAxios.connection().get(url);
				const { payment } = request.data;
				if (!payment.error) {
					this.payment = payment;
				} else {
					throw new Error(payment.message || 'Ocorreu um erro ao buscar os dados');
				}
			} catch (e) {
				this.$buefy.notification.open({
					message: e.message || 'Ops! Ocorreu um erro ao carregar os dados.',
					type: 'is-danger',
				});
			}
		},
		async handlePaymentProcess(situation) {
			if (this.hasPaymentProcess === true && situation === 10) return;

			this.loadingPaymentProcess = true;

			await ecAxios
				.connection()
				.put(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PEDIDO}${this.payment.orderId}`, {
					situacao: {
						situacao: situation,
					},
				})
				.then((response) => {
					if (response.status === 200) {
						this.hasPaymentProcess = true;
						this.loadingPaymentProcess = false;

						this.$buefy.notification.open({
							message:
								situation === 10
									? 'Sucesso! O pedido foi bloqueado para edição.'
									: 'Sucesso! O pedido foi liberado para edição.',
							type: 'is-success',
						});
					} else if (response.data.error !== 0) {
						throw new Error(response.data.message);
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.message || 'Ops! Ocorreu um erro ao validar seu pedido',
						type: 'is-danger',
					});
					this.loadingPaymentProcess = false;
					console.error(e);
				});

			setTimeout(() => {
				this.loadingPaymentProcess = false;
			}, 2000);
		},
	},
};
</script>

<style lang="scss" scoped>
.w-60 {
	width: 60%;
}

.link {
	color: #000;
	border-bottom: #000;
	align-items: center;
	display: flex;
}
.container-error {
	width: 60%;
	margin-bottom: 30px;
}
.icon-downloas {
	margin-right: 3px;
}
.loader-icon {
	animation: is-rotating 1s infinite;
	border: 2px solid #cecece;
	width: 15px;
	margin-right: 5px;
	border-top-color: #ff3b30;
	border-radius: 50%;
	height: 15px;
}

@keyframes is-rotating {
	to {
		transform: rotate(1turn);
	}
}

.error-message {
	margin-top: 3px;
}

.container-buttons {
	display: flex;
	width: 350px;
	align-items: center;
	align-self: center;
	margin-top: 20px;
	justify-content: space-between;
}

.error-message p {
	font-size: 10px;
	font-weight: bold;
	color: #cc352d;
}

.error-box {
	width: 100%;
	display: flex;
	flex-direction: column;
	border-left: 4px solid #976626;
	background-color: #cc352d11;
	border-radius: 4px;
	margin-bottom: 5px;
}
.sucess-messages {
	display: flex;
	width: 100%;
	flex-direction: column;
	border-left: 4px solid #28c76f;
	background-color: #28c76f11;
	border-radius: 4px;
	margin-bottom: 5px;
}
.icon-info {
	color: #fff;
	font-weight: bold;
	background-color: #ff8b07;
	padding: 4px;
	border-radius: 4px;
}
.sucess-box p {
	font-size: 12px;
	padding: 5px;
	font-weight: bold;
	color: #28c76f;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.error-message-custom p {
	font-size: 12px;
	padding: 5px;
	font-weight: bold;
	color: #cc352d;
}
.list-collumn {
	margin-top: 5px;
	font-size: 12px;
	width: 350px;
	display: flex;
	align-items: flex-start;
	flex-direction: column;
}
.creditCardAction {
	transition: 150ms ease-in-out;
}
.nsu {
	flex-direction: row;
	justify-content: space-between;
}
.grouped_row {
	margin-left: px;
	width: 49%;
}
.grouped_row_container {
	width: 350px;
	display: flex;
	font-size: 12px;
	justify-content: space-between;
}
.title-label {
	margin-bottom: 4px;
	margin-top: 10px;
}
.creditcardicon {
	width: 50%;
	padding-bottom: 10px;
}
.inline-item {
	display: flex;
	align-items: flex-start;
}
.inline-item span {
	font-size: 12px;
	margin-right: 4px;
}
.align-center {
	width: 100%;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
}

.my-modal-custom {
	position: fixed;
	z-index: 9999;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.24);
	display: table;
	transition: all 0.5s ease;
	overflow-y: scroll;
	align-items: flex-end;
}

.feather-icon {
	background-color: #ff3b30;
	padding: 2px;
	border-radius: 50%;
	color: #fff;
	cursor: pointer;
	transition: 300ms ease;
}

.feather-icon:hover {
	background-color: #cc342c;
}

.box-container-error {
	padding: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
	justify-content: center;
}

.box-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
	justify-content: center;
}

.modal-title {
	width: 100%;
	font-size: 14px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px;
	/*    border-bottom: 1px solid #dfdfe1c5; */
}
.modal-title h1 {
	font-weight: bold;
}

.container-modal {
	position: absolute;
	width: 450px;
	max-height: 100%;
	border-radius: 5px;
}

.box-modal {
	background-color: #fff;
	overflow: auto;
	width: 100%;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	padding-bottom: 30px;
	border-radius: 10px;
}

.cancelbutton {
	background-color: #cc352d;
	padding: 7px;
	width: 49%;
	border-radius: 5px;
	text-align: center;
	color: #fff;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: 500ms ease;
	font-size: 12px;
}

.cancelbutton:hover {
	background-color: #9c2c26;
}

.confirmButton {
	width: 49%;
	background-color: #007f00;
	padding: 7px;
	border-radius: 5px;
	text-align: center;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: 500ms ease;
	font-size: 12px;
}

.confirmButton:hover {
	background-color: #005700;
}
</style>

